'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var cloudStorageProfileTypes = {
    AWS_S3: 'AWS_S3',
    GCP_CLOUD_STORAGE: 'GCP_CLOUD_STORAGE',
    WASABI_OBJECT_STORAGE: 'WASABI_OBJECT_STORAGE',
    AZURE_BLOB_STORAGE: 'AZURE_BLOB_STORAGE'
};

var storageProfileTypes = _extends({
    ON_PREMISE_FILE_STORAGE: 'ON_PREMISE_FILE_STORAGE',
    ON_PREMISE_CLOUDIAN_OBJECT_STORAGE: 'ON_PREMISE_CLOUDIAN_OBJECT_STORAGE'
}, cloudStorageProfileTypes, {

    // At the time of writing, placeholders to represent Media Shuttle storage mapped to storage profiles
    AZURE_BLOB: 'AZURE_BLOB',
    S3_COMPATIBLE: 'S3_COMPATIBLE'
});

/**
 * @param {String} storageProfileType
 * @returns {boolean} - true if the storageProfileType is a cloudStorageProfileType
 */
var isCloudStorageProfileType = function isCloudStorageProfileType(storageProfileType) {
    return Object.values(cloudStorageProfileTypes).includes(storageProfileType);
};

module.exports = {
    cloudStorageProfileTypes: cloudStorageProfileTypes,
    storageProfileTypes: storageProfileTypes,
    isCloudStorageProfileType: isCloudStorageProfileType
};